import React, { useContext } from "react";
import { ListBox, Item, Section, Text } from "@adobe/react-spectrum";
import { navigate } from "gatsby";
import styled from "styled-components";
import Apps from "@spectrum-icons/workflow/Apps";
import { PluginContext } from "../contexts/PluginContext";

const Container = styled.div`
  width: 256px;
  border-right: 2px solid var(--spectrum-global-color-gray-300);
  /* padding-left: 10px; */
  padding-top: 10px;
  position: fixed;
  height: 100vh;
  z-index: 3;
  /* 100vh - header - footer - header's border */
  /* height: calc(100vh - 40px - 40px - 2px); */

  @media only screen and (min-width: 600px) {
    /* height: calc(100vh - 64px - 44px - 2px); */
  }

  @media only screen and (min-width: 900px) {
    /* padding-left: 10px; */
  }

  /* div[role="option"] {
    border-radius: 4px;
    margin: 2px;
  } */
`;

const NavbarLeft = () => {
  const { activePlugin, setActivePlugin } = useContext(PluginContext);
  const toToPluginPage = selection => {
    setActivePlugin(selection.currentKey);
    if (selection.currentKey === "allPlugins") {
      navigate("/plugins");
    } else {
      navigate(`/plugins/${selection.currentKey}`);
    }
  };
  return (
    <Container>
      <ListBox
        UNSAFE_className="list-box"
        width="256"
        aria-label="Alignment"
        selectionMode="single"
        disallowEmptySelection="false"
        selectedKeys={[activePlugin]}
        onSelectionChange={evt => toToPluginPage(evt)}
      >
        <Section title="Plugins">
          <Item key="allPlugins" textValue="All Plugins">
            <Text>All Plugins</Text>
            <Apps size="S" />
          </Item>
        </Section>
        <Section title="Image Processing">
          <Item key="alce" textValue="ALCE">
            <Text>ALCE</Text>
          </Item>
          <Item key="double-usm" textValue="Double USM">
            <Text>Double USM</Text>
          </Item>
        </Section>
        <Section title="Utilities">
          <Item key="theme-switcher" textValue="Theme Switcher">
            <Text>Theme Switcher</Text>
          </Item>
          <Item key="floating-adjustments" textValue="Floating Adjustments">
            <Text>Floating Adjustments</Text>
          </Item>
          <Item key="canvas-master" textValue="Canvas Master">
            <Text>Canvas Master</Text>
          </Item>
        </Section>
      </ListBox>
    </Container>
  );
};

export default NavbarLeft;
